
// https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser
import SiteWrapper from "./SiteWrapper"
export const wrapPageElement = SiteWrapper
